/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the IamApiConfiguration configuration object with a given root URL.
 */
export function provideIamApiConfiguration(rootUrl: string) {
  var config = new IamApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: IamApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class IamApiConfiguration {
  rootUrl: string = '/';
}

